module.exports = __webpack_public_path__ + "public/img/02.3fb01531.png";